module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5079.77878,209.075115 C5107.45914,212.105878 5118.81022,221.442855 5113.888,251.56561 C5116.67248,253.847442 5121.93498,258.289712 5120.85644,266.560257 C5119.7779,274.830802 5113.89813,276.480368 5113.3907,277.358164 C5112.88326,278.23596 5113.86617,286.51773 5105.65198,289.724884 C5091.34005,295.312836 5072.87781,280.747836 5071.36518,280.363221 C5069.85255,279.978607 5062.42136,284.755483 5049.14552,279.628111 C5040.45057,276.269963 5035.36914,262.057046 5051.60041,251.758963 C5051.02761,240.707901 5062.71566,207.206849 5079.77878,209.075115 Z",
      "id": "girl1_hair",
      "fill": "#6D8C4A",
      "transform": "translate(5081.000000, 250.000000) rotate(-10.000000) translate(-5081.000000, -250.000000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_bag_3",
      "fill": "#CDF1A5",
      "x": "5067",
      "y": "279",
      "width": "46",
      "height": "63",
      "rx": "15"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5044.36158,372.50491 C5044.28855,374.260297 5043.11052,375.199358 5041.93203,377.232696 C5040.55702,379.605099 5040.55816,383.941709 5039,387.554605 C5039.38417,388.41031 5041.90545,386.909039 5042.4585,385.454889 C5043.01155,384.000739 5043.43366,382.818154 5043.62079,382.451918 C5043.80792,382.085681 5044.24082,382.126341 5044.36125,382.482483 C5044.48168,382.838625 5044.37522,395.632181 5044.62587,396.268016 C5044.87651,396.90385 5046.38372,396.978589 5046.6663,396.339019 C5046.94887,395.699448 5047.26719,385.585213 5047.40394,385.318969 C5047.54069,385.052726 5047.8676,385.194537 5048.00263,385.339803 C5048.13766,385.485068 5047.51856,396.279728 5047.72966,396.689578 C5047.94077,397.099428 5049.50058,397.083956 5049.68065,396.757468 C5049.86073,396.430981 5050.29508,385.664341 5050.47297,385.425765 C5050.65086,385.187189 5050.99302,385.226506 5051.12581,385.448483 C5051.2586,385.67046 5050.51294,396.026856 5050.74006,396.480777 C5050.96718,396.934698 5052.47693,396.994273 5052.63168,396.546601 C5052.78644,396.09893 5053.45935,385.681344 5053.61091,385.534959 C5053.76247,385.388574 5053.95872,385.409588 5054.0933,385.551745 C5054.22788,385.693902 5054.10302,393.487833 5054.32914,393.919536 C5054.55526,394.351239 5055.69455,394.49103 5055.8813,393.973548 C5056.06805,393.456066 5055.92643,374.441143 5055.9857,373.388231 C5056.18323,369.87933 5054.33491,366.142772 5050.36926,366.004776 C5046.40362,365.86678 5044.5184,368.735361 5044.36158,372.50491 Z",
      "id": "girl1_right_hand",
      "fill": "#94B96B",
      "transform": "translate(5047.500000, 381.500000) rotate(9.000000) translate(-5047.500000, -381.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5054,329 L5054,329 L5054,329 C5057.31371,329 5060,331.686292 5060,335 L5060,380 L5060,380 C5060,383.313708 5057.31371,386 5054,386 L5054,386 L5054,386 C5050.68629,386 5048,383.313708 5048,380 L5048,335 L5048,335 C5048,331.686292 5050.68629,329 5054,329 Z",
      "id": "girl1_right_arm_bottom",
      "fill": "#94B96B",
      "transform": "translate(5054.000000, 357.500000) rotate(9.000000) translate(-5054.000000, -357.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_right_arm_top",
      "fill": "#94B96B",
      "transform": "translate(5060.000000, 313.500000) rotate(7.000000) translate(-5060.000000, -313.500000) ",
      "x": "5054",
      "y": "284",
      "width": "12",
      "height": "59",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5061.5,284 L5061.5,284 L5061.5,284 C5065.94528,284 5069.61989,287.46543 5069.88012,291.903089 L5071,311 L5052,311 L5053.11988,291.903089 L5053.11988,291.903089 C5053.38011,287.46543 5057.05472,284 5061.5,284 Z",
      "id": "girl1_right_sleeve",
      "fill": "#80A259",
      "transform": "translate(5061.500000, 297.500000) rotate(7.000000) translate(-5061.500000, -297.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5061.49382,481 L5074,481 L5074,505 L5068.29243,505 C5068.29243,504.089154 5067.80987,503.627911 5066.84473,503.616268 C5065.87959,503.604626 5065.40347,504.06587 5065.41638,505 L5049,505 C5049.30721,501.366728 5050.3739,499.123162 5052.20007,498.269301 C5057.19794,495.932451 5059.97142,493.15602 5060.56904,490.87477 C5061.01322,489.17923 5061.32148,485.887639 5061.49382,481 Z",
      "id": "girl1_right_shoe",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5068,419 L5068,419 L5068,419 C5071.31371,419 5074,421.686292 5074,425 L5074,481 L5062,481 L5062,425 L5062,425 C5062,421.686292 5064.68629,419 5068,419 Z",
      "id": "girl1_right_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_right_leg_top",
      "fill": "#94B96B",
      "x": "5062",
      "y": "338",
      "width": "12",
      "height": "94",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5083.49382,481 L5096,481 L5096,505 L5090.29243,505 C5090.29243,504.089154 5089.80987,503.627911 5088.84473,503.616268 C5087.87959,503.604626 5087.40347,504.06587 5087.41638,505 L5071,505 C5071.30721,501.366728 5072.3739,499.123162 5074.20007,498.269301 C5079.19794,495.932451 5081.97142,493.15602 5082.56904,490.87477 C5083.01322,489.17923 5083.32148,485.887639 5083.49382,481 Z",
      "id": "girl1_left_shoe",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5090,419 L5090,419 L5090,419 C5093.31371,419 5096,421.686292 5096,425 L5096,481 L5084,481 L5084,425 L5084,425 C5084,421.686292 5086.68629,419 5090,419 Z",
      "id": "girl1_left_leg_bottom",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5090,338 L5090,338 L5090,338 C5093.31371,338 5096,340.686292 5096,344 L5096,426 L5096,426 C5096,429.313708 5093.31371,432 5090,432 L5090,432 L5090,432 C5086.68629,432 5084,429.313708 5084,426 L5084,344 L5084,344 C5084,340.686292 5086.68629,338 5090,338 Z",
      "id": "girl1_left_leg_top",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5061.75683,338 C5064.46965,338 5092.54266,338 5095.24317,338 C5101.78697,345.851931 5107.03925,365.185264 5111,396 L5046,396 C5050.18233,366.241522 5055.43461,346.908188 5061.75683,338 Z",
      "id": "girl1_skirt",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5061.52189,288.012664 C5067.46323,277.228011 5088.59046,277.430694 5095.14439,288.012664 C5099.51367,295.06731 5102.79888,311.396422 5105,337 L5052,337 C5054.38704,311.531544 5057.561,295.202432 5061.52189,288.012664 Z",
      "id": "girl1_torso",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5087.49496,282 C5090.04005,282 5094.20024,283.395582 5095.32126,284.858371 C5083.33819,299.429417 5092.2597,325.206213 5104.41898,325.143232 C5104.58037,326.839513 5104.89671,329.439812 5105,330.992849 C5075.94253,331.598472 5077.57736,293.566359 5087.49496,282 Z",
      "id": "girl1_bag_2",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5062.54647,285.232397 C5064.11558,284.065025 5065.93744,282.92651 5069,282 C5061.59985,294.272028 5056.20175,309.997307 5054,323 C5054.98796,306.777992 5061.04391,286.35025 5062.54647,285.232397 Z",
      "id": "girl1_bag_1",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_book_2",
      "fill": "#AFD485",
      "transform": "translate(5056.500000, 323.000000) rotate(-9.000000) translate(-5056.500000, -323.000000) ",
      "x": "5040",
      "y": "299",
      "width": "33",
      "height": "48"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_book_1",
      "fill": "#CDF1A5",
      "transform": "translate(5065.500000, 324.500000) rotate(-9.000000) translate(-5065.500000, -324.500000) ",
      "x": "5049",
      "y": "303",
      "width": "33",
      "height": "43"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5048.36158,323.295074 C5048.28855,324.993836 5047.11052,325.902605 5045.93203,327.870351 C5044.55702,330.166225 5044.55816,334.362944 5043,337.859295 C5043.38417,338.687397 5045.90545,337.234554 5046.4585,335.827312 C5047.01155,334.42007 5047.43366,333.275633 5047.62079,332.92121 C5047.80792,332.566788 5048.24082,332.606137 5048.36125,332.95079 C5048.48168,333.295443 5048.37522,345.676304 5048.62587,346.291628 C5048.87651,346.906952 5050.38372,346.979279 5050.6663,346.360341 C5050.94887,345.741402 5051.26719,335.953432 5051.40394,335.695777 C5051.54069,335.438122 5051.8676,335.575358 5052.00263,335.715938 C5052.13766,335.856518 5051.51856,346.302962 5051.72966,346.699591 C5051.94077,347.09622 5053.50058,347.081247 5053.68065,346.765292 C5053.86073,346.449336 5054.29508,336.030007 5054.47297,335.799128 C5054.65086,335.568248 5054.99302,335.606296 5055.12581,335.821112 C5055.2586,336.035929 5054.51294,346.058247 5054.74006,346.497526 C5054.96718,346.936805 5056.47693,346.994458 5056.63168,346.561227 C5056.78644,346.127996 5057.45935,336.046462 5057.61091,335.904799 C5057.76247,335.763136 5057.95872,335.783472 5058.0933,335.921044 C5058.22788,336.058615 5058.10302,343.601129 5058.32914,344.018906 C5058.55526,344.436683 5059.69455,344.571964 5059.8813,344.071175 C5060.06805,343.570387 5059.92643,325.168848 5059.9857,324.149901 C5060.18323,320.754191 5058.33491,317.138167 5054.36926,317.004622 C5050.40362,316.871077 5048.5184,319.647123 5048.36158,323.295074 Z",
      "id": "girl1_left_hand",
      "fill": "#94B96B",
      "transform": "translate(5051.500000, 332.000000) rotate(-266.000000) translate(-5051.500000, -332.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5075,309 L5075,309 L5075,309 C5078.31371,309 5081,311.686292 5081,315 L5081,358 L5081,358 C5081,361.313708 5078.31371,364 5075,364 L5075,364 L5075,364 C5071.68629,364 5069,361.313708 5069,358 L5069,315 L5069,315 C5069,311.686292 5071.68629,309 5075,309 Z",
      "id": "girl1_left_arm_bottom",
      "fill": "#94B96B",
      "transform": "translate(5075.000000, 336.500000) rotate(-266.000000) translate(-5075.000000, -336.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl1_left_arm_top",
      "fill": "#94B96B",
      "x": "5090",
      "y": "284",
      "width": "12",
      "height": "59",
      "rx": "6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5095.5,284 L5095.5,284 L5095.5,284 C5099.94528,284 5103.61989,287.46543 5103.88012,291.903089 L5105,311 L5086,311 L5087.11988,291.903089 L5087.11988,291.903089 C5087.38011,287.46543 5091.05472,284 5095.5,284 Z",
      "id": "girl1_left_sleeve",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5072.52941,275.517109 C5075.93698,273.466255 5079.04435,273.522535 5082.47059,275.517109 C5082.47059,278.337503 5081.99563,281.141013 5084,282.432834 C5081.03751,287.097346 5073.99012,287.279889 5071,282.432834 C5072.44503,280.40149 5072.95284,278.232071 5072.52941,275.517109 Z",
      "id": "girl1_neck",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5075.97988,210.000484 C5103.33653,210.141409 5103.77637,226.140038 5103.52277,239.95195 C5116.83696,238.767346 5107.04171,265.792326 5097.22725,261.233256 C5096.02916,264.636971 5092.42722,277.215787 5074.406,276.997186 C5056.38477,276.778584 5050.27446,256.823551 5050.01086,243.104736 C5049.74727,229.385922 5054.16458,209.888104 5075.97988,210.000484 Z",
      "id": "girl1_face",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5066.00151,269.08493 C5067.32392,269.365486 5074.5205,269.420834 5077,269 C5076.8938,269.537191 5073.10459,271 5069.9266,271 C5066.74862,271 5065.96029,269.666667 5066.00151,269.08493 Z",
      "id": "girl1_mouth_bottom",
      "fill": "#80A259",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5066,268.970468 C5066,268.072125 5066.40776,267 5070.60243,267 C5073.50643,267 5078.23503,268.209649 5080.57436,267.656823 C5081.05836,267.518616 5081.21969,268.106336 5080.57436,268.313645 C5077.5897,269.211988 5075.0391,268.970468 5070.60243,268.970468 C5067.69843,268.901365 5066,268.970468 5066,268.970468 Z",
      "id": "girl1_mouth_top",
      "fill": "#80A259",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5068.7474,246.347326 C5069.15064,244.643265 5074.28176,244.460832 5074.28422,246.347326 C5074.28668,248.23382 5075.8935,258.147847 5074.28422,259.897038 C5072.67494,261.646228 5067.89756,261.060167 5067.16546,259.897038 C5066.43335,258.733908 5068.34417,248.051387 5068.7474,246.347326 Z",
      "id": "girl1_nose",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5068.27659,210.543986 C5095.96603,203.716424 5107.40602,220.866604 5110.9534,235.85342 C5114.50078,250.840237 5108.6536,257.886711 5099.09873,257.999176 C5089.54386,258.111641 5089.90652,246.676344 5088.82468,246.926298 C5087.76998,247.169983 5087.80399,255.59668 5076.97001,255.626416 C5066.13604,255.656153 5065.74846,248.971339 5064.32503,248.508138 C5062.90161,248.044937 5048.87696,259.588224 5044.56725,244.553539 C5041.48361,233.796035 5051.19496,214.755912 5068.27659,210.543986 Z",
      "id": "girl1_bangs",
      "fill": "#6D8C4A"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b74507f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/girl1.vue
// module id = 709
// module chunks = 1